/* Library */
import React, { Component } from 'react';
import _ from 'lodash';

import SelectionTabWithLabel from'../../../../../components/ZUILib/SelectionTabWithLabel';
//import SelectionTab from'../../../../../components/ZUILib/SelectionTab';
import TextInput from '../../../../../components/ZUILib/TextInput';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample';

import commonUtil from '../../../../../utils/commonUtil';
import CheckBox from '../../../../../components/ZUILib/CheckBox/CheckBox';
import { eventType, constChannel } from '../../../../../utils/clientConstant';
import { createTag, createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';


const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();

export default class EventCoOwnerType1 extends Component {
  constructor(props) {
    super(props);
    this.state={
      selectedValue: '',
      nombreBoda: this.props.userData ? this.props.userData.firstName : '',
      lastName: this.props.userData ? this.props.userData.lastName : '',
      surName2: this.props.userData ? this.props.userData.motherName : '',
      txtCellular: this.props.userData ? this.props.userData.phone : '',
      txtEmail: this.props.userData ? this.props.userData.email : '',
    }
    this.checkboxdetails = {
      emailDetail: '',
    };
    this.formData = {
      userData: {
        ownerLabel: '',
        firstName: '',
        phone: '',
        email: '',
        lastName: '',
        motherName: '',
        coOwner: '',
        isMinor:'',
        title : '',
        celebrity:''
      },
    };
    this.emailID = '';
    this.permitAccess = this.permitAccess.bind(this);
    this.displayCoOwnerDetails = this.displayCoOwnerDetails.bind(this);
    this.isPermit = this.props.isPermit;
    this.coOwnerOptional = this.props.optional;
  }

  componentDidMount() { // To get user data on back fom 2nd step.
    if (this.props.isChanged) {
      const option = {};
      option.value = this.props?.userData?.title;
      if(!this.props?.userData?.title) {
        option.value = "No"
      }
      this.displayCoOwnerDetails(option);
    }
    if (this.emailID) {
      this.showEmailData.setChecked(true);
      this.permitAccess();
    }
    if (this.props.userData && this.props.userData.dateOfBirth) {
      this._CalenderSample.setDate(this.props.userData.dateOfBirth);
    }
    if(channel === 'wap') {
      document.addEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
     if (channel === 'wap') {
        document.removeEventListener('click', this.handleClickOutside);
      }
  }

 

  // To get coOwner data on GiftRgistyClebated index page this getformData is using.
  getformData = () => this.formData.userData

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  }
  handleAllowOnlyDigit = (e) => {
    const keyCode = e.charCode;
    if (keyCode > 37 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  }


  handleFieldChange = (e) => {
    const { name, value } = e.target;
      this.setState({ [name]: value });
      this.props.onChange();
       switch (name) {
    case "nombreBoda":
      if (this.nombreBoda) this.nombreBoda.clearError();
      break;
    case "lastName":
      if (this.lastName) this.lastName.clearError();
      break;
    case "surName2":
      if (this.txtSurName2) this.txtSurName2.clearError();
      break;
    case "txtCellular":
      if (this.txtCellular) this.txtCellular.clearError();
      break;
    case "txtEmail":
      if (this.txtEmail) {
        this.props.setEmptyEmailError();
        this.txtEmail.clearError();
      }
      break;     
    default:
      break;
  }
    };


  // For validation.
  handleformValidate = () => {
    const ownerEmailId = this.props.ownerEmailId ? this.props.ownerEmailId : null;
    const celebrityEmailXvAnos = this.props.celebrityEmailXvAnos ? this.props.celebrityEmailXvAnos : null;
    let isFormValid = true;

    let titleValid = true;
    let firstNameValid = true;
    let nombreBodaValid = true;
    let emailValid = true;
    let birthDateValid = true;
    let maternalNameValid = true;
    let nickNameValid = true;
    let cellularValid = true;
    let motherNameValid = true;
    const configurationNumber = Number(commonUtil.getLabel(this.props?.lables?.createEventStep1, 'createEventStep1.inputconfiguration.number'))

    if(this.props.eventName !== eventType.Boda) {
      const titleValidValidationConfig = {
        functionRef: commonUtil.validateSelectedValue, funcData: [this.title.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      };
      titleValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title, null);
    }
    
    if (this.props.eventName === eventType.Boda || this.state.selectedValue === 'Si') {
      // const titleValidValidationConfig = {
      //   functionRef: commonUtil.validateSelectedValue, funcData: [this.title.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      // };
      // titleValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title, null);

      // const firstNameValidationRules = [
      //   { functionRef: commonUtil.isValueAvailable, funcData: [this.txtFirstName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
      //   { functionRef: commonUtil.validateName, funcData: [this.txtFirstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      // ];
      // firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.txtFirstName, null);

      const nombreBodaValidationRules = [
        { functionRef: commonUtil.validateLength, funcData: [this.nombreBoda.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.isValueAvailable, funcData: [this.nombreBoda.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.nombreBoda.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      nombreBodaValid = commonUtil.validateTextInput(nombreBodaValidationRules, this.nombreBoda, null);
      const maternalNameValidationRules = [
        { functionRef: commonUtil.validateLength, funcData: [this.lastName.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.isValueAvailable, funcData: [this.lastName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.lastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      maternalNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.lastName, null);
      // const birthDateValidationRules = {
      //   functionRef: commonUtil.isValueAvailable, funcData: [this._CalenderSample.state.date], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required')
      // };
      // birthDateValid = commonUtil.validateCalendarInput(birthDateValidationRules, this._CalenderSample, null);
      if(this.txtSurName2.getValue()) {
      const maternalNameValidationRules = [
         { functionRef: commonUtil.validateLength, funcData: [this.txtSurName2.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
         { functionRef: commonUtil.isValueAvailable, funcData: [this.txtSurName2.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.txtSurName2.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      motherNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.txtSurName2, null);
    }
      if (this.isPermit) {
        const emailValidationRules = [
          { functionRef: commonUtil.isValueAvailable, funcData: [this.txtEmail.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.validateEmail, funcData: [this.txtEmail.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
          { functionRef: commonUtil.compareEmail, funcData: [this.txtEmail.getValue(), ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error2') },
          ...((this.props.eventName === eventType.XV_Anos && celebrityEmailXvAnos) ? [{ functionRef: commonUtil.compareEmail, funcData: [this.txtEmail.getValue(), celebrityEmailXvAnos], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error2') }] : [])
        ];

        emailValid = commonUtil.validateTextInput(emailValidationRules, this.txtEmail, null);
        const CellularValidationRules = [
          { functionRef: commonUtil.isValueAvailable, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        ];
        cellularValid = commonUtil.validateTextInput(CellularValidationRules, this.txtCellular, null);
      }
    }    

    // if (this.txtnickName.getValue()) {
    //   const nickNameValidationRules = [
    //     // { functionRef: commonUtil.validateLength, funcData: [this.txtnickName.getValue(), 1], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
    //     { functionRef: commonUtil.validateNameForAlphaNumeric, funcData: [this.txtnickName.getValue(), 1, false], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
    //   ];
    //   nickNameValid = commonUtil.validateTextInput(nickNameValidationRules, this.txtnickName, null);
    // }
    // if (this.txtCellular.getValue()) {
    //   const CellularValidationRules = [
    //     { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
    //   ];
    //   cellularValid = commonUtil.validateTextInput(CellularValidationRules, this.txtCellular, null);
    // }

    isFormValid = (titleValid && firstNameValid && nombreBodaValid && emailValid && birthDateValid && maternalNameValid && nickNameValid && cellularValid && motherNameValid);
    if (isFormValid) {
        const userData = {
            ownerLabel: this.props.eventDetail?.labels[this.props.index],
            profileId: '',
            isMinor: 'false',
            coOwner: 'true',
            celebrity: 'false'
        };

        if (this.props.eventName !== eventType.Boda && this.title.getValue()) {
            userData.title = this.title.getValue();
        }

        if (this.nombreBoda.getValue() && this.nombreBoda.getValue().length >= configurationNumber) {
            userData.firstName = this.nombreBoda.getValue();
        }

        if (this.lastName.getValue()) {
            userData.lastName = this.lastName.getValue();
        }

        if (this.txtSurName2 && this.txtSurName2.getValue()) {
            userData.motherName = this.txtSurName2.getValue();
        }

        if (this.isPermit && this.txtCellular.getValue()) {
            userData.phone = this.txtCellular.getValue();
        }

        if (this.isPermit && this.txtEmail.getValue()) {
            userData.email = this.txtEmail.getValue();
        }

        this.formData = { userData };
        return true;
    }

    const controls = [this.title, this.nombreBoda, this.lastName, this.txtCellular, this.txtEmail];
    const tagCompositor = c => ({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      color: 'Rojo',
      mensaje: 'Datos incompletos del festejado 2',
      mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
      seccion: 'Mesa de Regalos',
      tipo: 'formulario',
    });
    createTagsForInvalidFormControls({ controls, tagCompositor });

    //  if (!nombreBodaValid) {
    //   this.props.focusOnError('nombreBodaId');
    // } else if (!maternalNameValid) {
    //   this.props.focusOnError('primerApellidoId');
    // } else if (!nickNameValid) {
    //   this.props.focusOnError('nickName1');
    // } else if (!cellularValid) {
    //   this.props.focusOnError('phone1');
    // } else if (!emailValid) {
    //   this.props.focusOnError('email1');
    // } else if(!titleValid) {
    //   this.props.focusOnError('id');
    // }
    return false;
  }

  permitAccess() { // It is used to make permision checkbox checked.
    if (this.showEmailData.isChecked()) {
      this.isPermit = true;
      this.forCheck.style.display = 'block';
    } else {
      this.isPermit = false;
      this.forCheck.style.display = 'none';
    }
    this.props.onChange()
  }

displayCoOwnerDetails(opt) {
  this.setState({ selectedValue: opt.value }, () => {

    if (this.title && this.title.clearError) {
      this.title.clearError();
    }
    this.props.onChange();
    
    // if (opt.value === 'No') {
    //   this.nombreBoda.setValue('');
    //   this.lastName.setValue('');
    //   this.txtSurName2.setValue('');
    //   this.txtCellular.setValue('');
    //   this.txtEmail.setValue('');
    // }
    
  });
}

  handlePopUpCoOwner = (e,id) => {
    if (channel === 'wap') {
      e.stopPropagation();
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  }
  
  handleClickOutside = (event) => {
    if (channel === 'wap') {
      const tooltip = document.querySelector('#helpPopup1');
      if (tooltip && !tooltip.contains(event.target) && tooltip.style.display === 'block') {
        tooltip.style.display = 'none';
      }
    }
  }

  render() {
    const { eventDetail, userData, lables, emailError } = this.props;

    let SelectionOptions = [];
    const textInputAttr = {
      textClassName: 'form-control',
      textLabelClassName: 'label_one',
      textHtmlId: 'calendar1',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.dob.label'),
      textRequired: true,
    };
    SelectionOptions = ["Si","No"].map((data) => {
      const title = {};
      title.id = data;
      title.labelResourceId = data;
      title.value = data;
      return title;
    });
    this.emailID = (userData && userData.email) ? userData.email : '';
    const eventName = !!(this.props.eventName && this.props.eventName !== eventType.Boda);

    return (
      <React.Fragment>
        <div className="formBlock wap_padding_inline">
          <h2 className="subtitleModule titleForm SectionTwoHeading">
            {/* { (!eventName) ? commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.cuentenaosSobre.label'):commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.estasOranizado.label')} */}
            {this.props.getFormHeadingLabelByEventType(this.props.eventName, 'right')}
          </h2>
        </div>
        <div className="formBlock  wap_padding_inline">
          { eventName ?
            <SelectionTabWithLabel
              id={'id'}
              classname="cSelect required"
              options={SelectionOptions}
              optionCaption={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.selecttitle2.label')}
              optionText={'labelResourceId'}
              optionValue={'value'}
              star="*"
              required="true"
              value={userData && userData.title ? userData.title : this.props.isChanged ? "No" : ""}
              ref={el => (this.title = el)}
              handleSelectedOption={this.displayCoOwnerDetails}
              enable={SelectionOptions.length > 0}
              src={commonUtil.getAssetURL() + '/images/expand_more.svg'}
            />
          :
           
            <></>
        }
        </div>
        <div style={{ display: (this.props.eventName === eventType.Boda) ? "block" : this.state.selectedValue === "Si" ? 'block' : 'none' }} ref={sValue => this.selectedOpton = sValue}>
          { eventName && <div className="formBlock  wap_padding_inline ">
            <h2 className='sectionTwoBHeading'>{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.agregaSuDatos.label')}</h2>
          </div>}
          <div className="formBlock  wap_padding_inline">
            <TextInput
              doNotUpdateOnPropsChange="true"
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="nombreBodaId"
              label={this.props.eventName === eventType.Boda ? "Nombre(s) de tu pareja" : "Nombre"}
              maxlength="100"
              required="true"
              value={this.state.nombreBoda}
              star="*"
              ref={nombreBoda => this.nombreBoda = nombreBoda}
              name="nombreBoda"
              onChange={this.handleFieldChange}
              createEvent={true}
            />
          </div>
          <div className="formBlock  wap_padding_inline">
            <TextInput
              doNotUpdateOnPropsChange="true"
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="primerApellidoId"
              label="Primer apellido"
              required="true"
              maxlength="100"
              star="*"
              value={this.state.lastName}
              ref={lastName => this.lastName = lastName}
              name="lastName"
              onChange={this.handleFieldChange}
              createEvent={true}
            />
          </div>
          <div className="formBlock  wap_padding_inline">
            <TextInput
              doNotUpdateOnPropsChange="true"
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="surName2"
              label="Segundo apellido"
              required="false"
              maxlength="100"
              value={this.state.surName2}
              ref={txtSurName2 => this.txtSurName2 = txtSurName2}
              name="surName2"
              onChange={this.handleFieldChange}
              createEvent={true}
            />
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 moreOptionsWAP tooltipBackdropBoda">
              <div className="formBlock moreOptionsWEB">
                <div className="inLine whiteSpaceNoWrap">
                  <CheckBox htmlId={this.props.id + '_showEmailCoOwner'} displayName={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.checkboxTxt.label')} ref={chk => this.showEmailData = chk} getSelectedValue={this.permitAccess} />
                </div>
                <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                  {/* < i  className="icon-ayuda" /> */}
                  <img src={commonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={(e) => { this.handlePopUpCoOwner(e,'helpPopup1'); }} />
                  <div className="tooltip-backdrop" />
                  <div id="helpPopup1" className="popover bottom helpIconCssEmail">
                    <div className="arrow" />
                    <div className="popover-content">
                          {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.popoverContent.label')}
                      {/* <ul dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.permissionAlias.message') }} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 moreOptionsWAP permitAccess" style={{ display: 'none' }} ref={(forCheck) => { this.forCheck = forCheck; }}>
              {/* <div className="formBlock">
                <p className="descriptInfoAditional">{commonUtil.getLabel(lables.createEventStep1, 'eventCreation.stage1.permissionToCoowner.notify')}</p>
              </div> */}
              <div className="formBlock">
                <TextInput
                  doNotUpdateOnPropsChange="true"
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  htmlId="phone1"
                  label="Celular"
                  required="true"
                  maxlength="10"
                  star="*"
                  value={this.state.txtCellular}
                  onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                  onPaste={(e) => { this.onPasteFunc(e); }}
                  ref={txtCellular => this.txtCellular = txtCellular}
                  name="txtCellular"
                  onChange={this.handleFieldChange}
                  createEvent={true}
                />
              </div>
              <div className="formBlock ">
                <TextInput
                  doNotUpdateOnPropsChange="true"
                  className={`inputMaterial ${emailError ? 'input-error' : ''}`}
                  labelClassName={`placeHolderMaterial ${emailError ? 'label-error' : ''}`}
                  htmlId="email1"
                  label={commonUtil.getLabel(lables.createLogin, 'create.account.email')}
                  maxlength="100"
                  required="true"
                  star="*"
                  value={this.state.txtEmail}
                  ref={txtEmail => this.txtEmail = txtEmail}
                  name="txtEmail"
                  onChange={this.handleFieldChange}
                  createEvent={true}
                />
              </div>
              { emailError && (<span name ='emailSpanError'className="input-error-message" id="emailError" ref={(emailError) => this.emailError = emailError}>{emailError}</span>)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
